import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { registreerServiceWorker } from './lib/push';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('Element #root niet gevonden in index.html');
}

/* Voor pushmeldingen; zie lib/push.ts. */
registreerServiceWorker();

/* De badge op het app-icoon (MA-43) gaat weg zodra je de app opent: dan heb je hem gezien. */
function wisBadge() {
  if (document.visibilityState === 'visible' && 'clearAppBadge' in navigator) {
    navigator.clearAppBadge().catch(() => {});
  }
}
wisBadge();
document.addEventListener('visibilitychange', wisBadge);

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
